/**
 * Public-facing routes for the DefaultNavbar.
 * Dashboard routes are in sidenavRoutes.js.
 */

const routes = [];

export function filterRoutesByRole(routes, userRoles) {
  return routes
    .filter(route => {
      if (route.excludedRoles && route.excludedRoles.some(role => userRoles.includes(role))) {
        return false;
      }
      if (route.allowedRoles) {
        return route.allowedRoles.some(role => userRoles.includes(role));
      }
      return true;
    })
    .map(route => {
      if (route.collapse) {
        return {
          ...route,
          collapse: filterRoutesByRole(route.collapse, userRoles),
        };
      }
      return route;
    });
}

export default routes;
